module.exports = __webpack_public_path__ + "img/sup_cardsetting_bank2.c803619c.jpg";